// extracted by mini-css-extract-plugin
export default {"overlay":"ChoiceBox_overlay__swK6V","container":"ChoiceBox_container__ZXW7W","title":"ChoiceBox_title__M7lW3"};